module.exports = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_xfBase.js
// module id = 165
// module chunks = 168707334958949